import { createAlgoliaIndices } from '@/utils'
import { mapState, mapActions } from 'vuex'
import { clearSonarAssessment } from '@/sonar/helpers/sessionStorageHandler'
import { compact } from 'lodash'

export const recommendedContent = {
  data() {
    return {
      currentItems: [],
      indices: {
        Courses: {},
        'Learning Paths': {},
        Videos: {},
        Bootcamps: {},
        Labs: {},
      },
    }
  },
  computed: {
    ...mapState({
      algoliaKeys: state => state.search.algoliaKeys,
      facets: state => state.search.facets,
      searchIndex: state => state.sonar.algoliaSearchIndex,
    }),
  },
  methods: {
    ...mapActions({
      getAssessmentRecommendations: 'sonar/getAssessmentRecommendations',
      setAlgoliaSearchIndex: 'sonar/setAlgoliaSearchIndex',
    }),
    async getAlgoliaItems(payload) {
      const content = await this.getAssessmentRecommendations(payload)
      const contentIds = content?.map(c => c.content_id)
      return await this.getAlgoliaObjects(contentIds)
    },
    async getAlgoliaObjects(contentIds) {
      if (!contentIds?.length) return []
      this.createAlgoliaSearchInstance()
      const { results } = await this.searchIndex.algoliaIndex.getObjects(
        contentIds
      )
      return compact(results) //remove empty results
    },
    createAlgoliaSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, searchIndex },
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'contentSearch',
            index: searchIndex,
            facets: this.facets.CONTENT,
          },
        ],
        disjunctiveFacets: true,
        initWithSearch: false,
      }
      const { instance, indices } = createAlgoliaIndices(setup)
      this.algoliaClient = instance
      this.setAlgoliaSearchIndex(indices?.contentSearch)
    },
  },
}

export const assessmentHandler = {
  inject: ['getBreakpoint'],
  computed: {
    isScreenSizeAllowed() {
      return ['tablet', 'desktop', 'lg-desktop'].includes(this.getBreakpoint())
    },
  },
  methods: {
    ...mapActions({
      updateSonarStatus: 'sonar/updateSonarStatus',
      setLastQuestionAnswered: 'sonar/setLastQuestionAnswered',
    }),
    goToAssessment(assessmentId = this.assessment?.id) {
      if (!this.isScreenSizeAllowed)
        return this.updateSonarStatus({ showStartAssessmentModal: true })
      this.setLastQuestionAnswered(false)
      clearSonarAssessment()
      return this.$router.push({
        name: 'sonar-quiz',
        params: { assessmentId },
      })
    },
  },
}
